import React from 'react';
const Events = () =>{
    return(
    <div>
        <p>Events page</p>
    </div>
    )
}
export default Events